import React from 'react';
import { MessageText, FlexMessage, MessageTextContainer, IconContainer } from './styled';
import { colors, WarningIcon } from '@chegg-ui/theme';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { MessageType } from '../../redux/message/message.types';
var MessageBox = function MessageBox(props) {
  var text = props.text,
    messageType = props.messageType;
  var renderErrorMessageBox = function renderErrorMessageBox(text) {
    var coral = colors.coral;
    return /*#__PURE__*/React.createElement(FlexMessage, {
      role: "alert",
      "data-test": DataTestAttributes.MESSAGE_BOX,
      "aria-live": "polite"
    }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(WarningIcon, {
      size: "medium",
      svgColor: coral
    })), /*#__PURE__*/React.createElement(MessageTextContainer, null, /*#__PURE__*/React.createElement(MessageText, {
      "data-test": DataTestAttributes.MESSAGE_BOX_TEXT
    }, text)));
  };
  if (messageType === MessageType.ERROR) {
    return renderErrorMessageBox(text);
  } else {
    return null;
  }
};
export default MessageBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/MessageBox/MessageBox.js
// module id = 4655
// module chunks = 11